var $f4136d995a29eff2$exports = {};
$f4136d995a29eff2$exports = {
    "backButton": (args)=>`Volver a ${args.prevMenuButton}`,
    "moreActions": `M\xe1s acciones`,
    "unavailable": `No disponible, ampliar para m\xe1s detalles`
};


export {$f4136d995a29eff2$exports as default};
//# sourceMappingURL=es-ES.mjs.map
